// extracted by mini-css-extract-plugin
export default {"description":"ArticlesDescription_description__oZSa3"};